import { Box, Stack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import GeneralCalendarFocusOfTheDay from './GeneralCalendarFocusOfTheDay.js';
import { getCalendarFocusOfTheDayData } from '../../services/CalendarFocusOfTheDay.js';
import MyTabsNested from '../../components/MyTabsNested.js';
import Section1 from './Section1.js';

const EditCalendarFocusOfTheDayRecord = () => {

    const { alias } = useParams();
    const [calendarEventTitle, setCalendarEventTitle] = useState('');
    const location = useLocation();
    const navigate = useNavigate();

    const tabs = useMemo(() => [
        {
            id: "general", title: "General", Component: GeneralCalendarFocusOfTheDay, subTabs: [
                { id: "primary", title: "Primary", Component: Section1 }
            ]
        }
    ], []);

    useEffect(() => {
        const getBasicData = async () => {
            try {
                if (alias) {
                    const result = await getCalendarFocusOfTheDayData(alias);

                    if (result) {
                        setCalendarEventTitle(result?.data?.[0]?.title || result?.data?.[0]?.alias);
                    }
                }
            } catch (error) {
                console.error('Error fetching Calendar Event data:', error);
            }
        };

        getBasicData();
    }, [alias]);

    // Redirect to default tab if no tab is specified
    useEffect(() => {
        const pathParts = location.pathname.split('/');
        if (pathParts?.length === 4 && alias) {
            // Redirect to the default tab/subTab
            navigate(`/calendar/focus-of-the-day/${alias}/${tabs[0].id}/${tabs?.[0].subTabs?.[0].id}`, { replace: true });
        }
    }, [location.pathname, alias, navigate, tabs]);

    return (
        <Stack px="1rem" pb={'1rem'} width={"100%"}>
        <Box>
          <Text fontSize={"18px"} pt={2} fontWeight={"600"}>{calendarEventTitle}</Text>
        </Box>
            <MyTabsNested orientation="vertical" list={tabs} urlBasePath={"/calendar/focus-of-the-day"} tabSegmentPosition={3} subTabSegmentPosition={4} />
        </Stack>
    );
};

export default EditCalendarFocusOfTheDayRecord;